const defaultSlickOptions = {
  variableWidth: true,
  centerMode: true,
  draggable: false,
  autoplay: true,
  autoplaySpeed: 0,
  arrows: false,
  pauseOnFocus: false,
  pauseOnHover: false,
  pauseOnDotsHover: false,
  dots: false,
  speed: 300,
  // responsive: [
  //   {
  //     breakpoint: 960,
  //     // settings: {
  //     //   swipe: true,
  //     //   draggable: true,
  //     // }
  //   }
  // ]
};

const $ = window.jQuery;

export class SlickSlider {
  constructor(el, options = {}) {
    this.el = el;
    this.initSlick(options);
  }

  initSlick(options) {
    if (typeof $ !== 'function') {
      return;
    }

    if (typeof $.fn?.slick !== 'function') {
      return;
    }

    return $(this.el).slick({
      ...defaultSlickOptions,
      ...options,
    });
  }
}